import React, {useEffect, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, isResponsive, isSmartphone} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import useModal from "../../components/Modal/UseModal";
import OfferModale from "../Offer/OfferModale";
import Toaster from "../../components/Toaster";
import ProductThumbView from "./ProductView/ProductThumbView";
import ProductListView from "./ProductView/ProductListView";
import {applyFiltersButton, buttonDeleteFilters} from "../../components/UtilsForCart";
import {useLocation, useNavigate } from "react-router-dom";
import {isProductInUserCatalog} from "../../components/Catalogue/userCatalogUtils";
import Pagination from "../../components/Pagination";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";

interface ComponentProps {
  products: any,
  totalItems: number,
  resetFilters: any,
  filtersSelected: {index: string, values: string[]}[],
  currentPage: number
  itemsPerPage: number
  groupCode: string
  taxonomiesSelected : any
  filtersSelectedParent: any
  setNewViewProduct: any
  newViewProduct: string,
  pendingFilters: {index: string, values: string[]}[],
  setFiltersSelected: React.Dispatch<React.SetStateAction<{index: string, values: string[]}[]>>,
  setIsEndOfStock: React.Dispatch<React.SetStateAction<boolean>>,
  isEndOfStock: boolean,
  groupCodeParent: string,
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  topPageId: string;
  isLoading: boolean;
}
const ProductsCatalogue: React.FC<ComponentProps> = ({products, totalItems, resetFilters,
                                                       filtersSelected, currentPage, itemsPerPage,
                                                       groupCode, taxonomiesSelected, filtersSelectedParent,
                                                       setNewViewProduct, newViewProduct,
                                                       pendingFilters, setFiltersSelected,
                                                       setIsEndOfStock, isEndOfStock, groupCodeParent,
                                                     setCurrentPage, topPageId, isLoading}: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);
  const [isToasterForCart, setIsToasterForCart] = useState(false);
  const [promoBannerText, setPromoBannerText] = useState<string|null>(null);
  const dispatch = useDispatch();
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false);

  useEffect(() => {
    if (!isLoading && products?.items) {
      setHasFetchedOnce(true);
    }
  }, [isLoading, products]);
  const {isShowing, toggle} = useModal();
  const [showToaster, setShowToaster] = useState(false);
  const userAccount = useSelector((state:RootState) => state.userRdc.userDetail?.customer);
  const isRequestingAdd = useSelector((state:RootState) => state.userRdc.isRequestingAdd);
  const brandInfo = useSelector((state:RootState) => state.productsRdc.brandInfo);
  const brandDetail = useSelector((state:RootState) => state.brandRdc.brand)
  const promotionBannerTexts = useSelector((state:RootState) => state.productsRdc.promoBannerTexts);
  const [productIdRequest, setProductIdRequest] = useState(0);
  const userCatalogs = useSelector((state: RootState) => state.userRdc.userCatalog);
  const hasUserCatalog = Array.isArray(userCatalogs) && userCatalogs.length > 0;

  const filteredProducts = Array.isArray(products?.items)
    ? hasUserCatalog && userCatalogs.length > 0
      ? products.items.filter((productItem: any) =>
        isProductInUserCatalog(productItem.id, userCatalogs))
      : products.items
    : [];
  const location = useLocation();
  const navigate = useNavigate();

  const totalDisplayedProducts = hasUserCatalog
    ? filteredProducts.length
    : totalItems;

  //const brandNameInUrl = GetUrlParams()["brand"];
  const currentBrand = brandInfo !== null ? brandInfo : brandDetail !== undefined ? brandDetail : null


  useEffect(() => {
      if(promotionBannerTexts && promotionBannerTexts.length > 0){
        try
        {
          setPromoBannerText(promotionBannerTexts[Math.floor(Math.random() * promotionBannerTexts.length)]);
        }
        catch(err)
        {
          setPromoBannerText(promotionBannerTexts[0]);
        }
      }
    }, [promotionBannerTexts]
  );

  // const [effectExecuted, setEffectExecuted] = useState(false);

  // useEffect(() => {
  //   if (!effectExecuted && brandNameInUrl !== undefined) {
  //     dispatch(getBrandBySlug(locale, brandNameInUrl));
  //     setEffectExecuted(true);
  //   }
  // }, [effectExecuted]);

  let history = useNavigate();
  const numberOfPages = hasUserCatalog
    ? Math.ceil(filteredProducts.length / itemsPerPage)
    : Math.ceil(totalItems / itemsPerPage);
  const shouldShowPagination = numberOfPages > 1;
  const allPages = Array.from({ length: numberOfPages }, (_, i) => i + 1);

  return (
    <>
      {/*{*/}
      {/*  promoBannerText ?*/}
      {/*    <div className="row mb-0">*/}
      {/*      <header className="border-top py-3 d-flex align-items-center justify-content-between py-2">*/}
      {/*        <div className="alert alert-info mb-0">*/}
      {/*          {promoBannerText}*/}
      {/*        </div>*/}
      {/*      </header>*/}
      {/*    </div>*/}
      {/*    :""*/}
      {/*}*/}
      {/*{*/}
      {/*  currentBrand ?*/}
      {/*    <div className="row mb-0">*/}
      {/*      <header className="border-top py-3 d-flex align-items-center justify-content-between py-2 container-brand-info">*/}
      {/*        <div className="col-md-2 col-sm-12">*/}
      {/*          {*/}
      {/*            currentBrand.logo && <img src={URL_FOR_RESOURCES + "/" + currentBrand.logo} className="img-sm border rounded" alt={`${currentBrand.name}-logo`}/>*/}
      {/*          }*/}
      {/*        </div>*/}
      {/*        <div className="col-md-11 col-sm-12">*/}
      {/*          <h5>{currentBrand.name}</h5>*/}
      {/*          {*/}
      {/*            currentBrand.description && <p className="mb-0" dangerouslySetInnerHTML={{ __html: currentBrand.description }} />*/}
      {/*          }*/}
      {/*        </div>*/}
      {/*      </header>*/}
      {/*    </div>*/}
      {/*    :*/}
      {/*    null*/}
      {/*}*/}

      {
        !isResponsive && !isSmartphone ?
          <div className="row mb-0">
            <header className="border-bottom border-top py-3 d-flex justify-content-between py-2 mb-3">
              <div className="content-button">
                {
                  // filtersSelected.length !== 0 ?
                  applyFiltersButton(
                    history,
                    false,
                    pendingFilters,
                    setFiltersSelected,
                    newViewProduct,
                    isEndOfStock
                  )// :
                  // null
                }
                {
                  // on affiche le boutton lorsqu'il n'y a pas de filtres/taxonomies sélectionné(e)s
                  taxonomiesSelected.length !== 0 || filtersSelected.length !== 0 || filtersSelectedParent !== "" ?
                    buttonDeleteFilters(resetFilters)
                    :
                    null
                }
              </div>
              <strong className="d-block">
                {totalDisplayedProducts} {totalDisplayedProducts > 1 ? t('products_found') : t('product_found')}
              </strong>

              <div className="btn-group change-view-products">
                <button
                  className={newViewProduct === "list" ? "btn btn-light active" : "btn btn-light"}
                  onClick={() => {
                    if (newViewProduct !== "list") {
                      setNewViewProduct("list");
                      const params = new URLSearchParams(location.search);
                      params.set("view", "list");
                      params.set("page", "1");
                      navigate({search: params.toString()});
                    }
                  }}
                >
                  <i className="fa fa-bars"/>
                </button>
                <button
                  className={newViewProduct === "thumb" ? "btn btn-light active" : "btn btn-light"}
                  onClick={() => {
                    if (newViewProduct !== "thumb") {
                      setNewViewProduct("thumb");
                      const params = new URLSearchParams(location.search);
                      params.set("view", "thumb");
                      params.set("page", "1");
                      navigate({search: params.toString()});
                    }
                  }}
                >
                  <i className="fa fa-th"/>
                </button>
              </div>

            </header>
          </div>
          : null
      }

      <div className={newViewProduct === "thumb" ? "row" : "row g-0"}>
        {
          isLoading ? (
            <SpinnerOnTop />
          ) : !isLoading && hasFetchedOnce && filteredProducts.length === 0 ? (
            <div className="alert alert-warning">
              {!isEndOfStock ? t('no_product') : t('no_product_in_stock')}
            </div>
          ) : null
        }
        {
          filteredProducts && filteredProducts.map((productItem: any, index: number) =>
            newViewProduct === 'thumb' ?
              // thumb view for product
              <ProductThumbView
                userAccount={userAccount}
                productItem={productItem}
                isRequestingAdd={isRequestingAdd}
                productIdRequest={productIdRequest}
                setProductIdRequest={setProductIdRequest}
                key={index}
              />
              :
              newViewProduct === 'list' ?
                // list view for product
                <ProductListView
                  userAccount={userAccount}
                  productItem={productItem}
                  isRequestingAdd={isRequestingAdd}
                  productIdRequest={productIdRequest}
                  setProductIdRequest={setProductIdRequest}
                  key={index}
                />
                : null
          )
        }
      </div>
      <OfferModale
        isShowing={isShowing}
        hide={toggle}
      />
      <Toaster showToaster={showToaster} setShowToaster={setShowToaster} isToasterForCart={isToasterForCart} setIsToasterForCart={setIsToasterForCart}/>

      {
        shouldShowPagination && (
        <Pagination
          allPages={allPages}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          topPageId={topPageId}
          numberOfPages={numberOfPages}
        />
        )
      }
      </>
  )
}
export default ProductsCatalogue;


